import {assert} from 'Asserts';
import {ContainerSummary, GridSummary, LocationSummary, StorableSummary} from 'constants/SampleConstants';
import {graphQLToREST, restToGraphQL} from 'graphql-client/declarative-translations/external/translate';
import APIUtil from 'util/APIUtil';

import {StorableSummaryGraphQL} from '../../../../graphql-fragments/inventory/__generated/StorableSummaryGraphQL';

type StorableSummaryREST = StorableSummary | ContainerSummary | LocationSummary;

/*
 * @deprecated Stepping stone while removing Declarative Translations - these functions will be going away soon
 */
export function graphQLStorableSummaryToREST(storable: StorableSummaryGraphQL): StorableSummaryREST {
  if (storable.__typename === 'BoxNode') {
    return graphQLToREST('BoxSummary', storable);
  } else if (storable.__typename === 'PlateNode') {
    return graphQLToREST('PlateSummary', storable);
  } else if (storable.__typename === 'ContainerNode') {
    return graphQLToREST('ContainerSummary', storable);
  } else if (storable.__typename === 'LocationNode') {
    return graphQLToREST('LocationSummary', storable);
  } else {
    assert(false, `Unexpected storable type: ${storable}`);
  }
}

/*
 * @deprecated Stepping stone while removing Declarative Translations - these functions will be going away soon
 */
export function nullableGraphQLStorableSummaryToREST(
  storable: StorableSummaryGraphQL | null | undefined
): StorableSummaryREST | null {
  if (storable == null) {
    return null;
  }
  return graphQLStorableSummaryToREST(storable);
}

/*
 * @deprecated Stepping stone while removing Declarative Translations - these functions will be going away soon
 */
export function restStorableSummaryToGraphQL(storable: StorableSummaryREST): StorableSummaryGraphQL {
  if (APIUtil.isBox(storable.id)) {
    return restToGraphQL('BoxSummary', storable as GridSummary);
  } else if (APIUtil.isPlate(storable.id)) {
    return restToGraphQL('PlateSummary', storable);
  } else if (APIUtil.isContainer(storable.id)) {
    return restToGraphQL('ContainerSummary', storable as ContainerSummary);
  } else if (APIUtil.isLocation(storable.id)) {
    return restToGraphQL('LocationSummary', storable as LocationSummary);
  } else {
    assert(false, `Unexpected storable type: ${storable.id}`);
  }
}

/*
 * @deprecated Stepping stone while removing Declarative Translations - these functions will be going away soon
 */
export function nullableRESTStorableSummaryToGraphQL(
  storable: StorableSummaryREST | null | undefined
): StorableSummaryGraphQL | null {
  if (storable == null) {
    return null;
  }
  return restStorableSummaryToGraphQL(storable);
}

/*
 * @deprecated Stepping stone while removing Declarative Translations - these functions will be going away soon
 */
export function restStorableSummariesByIdToGraphQL(
  storableSummariesById: Record<string, Array<StorableSummary>>
): Record<string, Array<StorableSummaryGraphQL>> {
  if (!storableSummariesById) {
    // strictly, this should be impossible, but it seems to come up anyway
    return storableSummariesById;
  }
  const storableSummariesByGraphQLId: Record<string, Array<StorableSummaryGraphQL>> = {};
  Object.entries(storableSummariesById).forEach(([id, storableSummaries]) => {
    storableSummariesByGraphQLId[id] = storableSummaries.map((storableSummary) =>
      restStorableSummaryToGraphQL(storableSummary)
    );
  });
  return storableSummariesByGraphQLId;
}
